import compass_inner from './compass-inner';
import compass_outer from './compass-outer';
import compass_rotation_marker from './compass-rotation-marker';

const Icons = {
  compass_outer,
  compass_inner,
  compass_rotation_marker,
};

export default Icons;
